import React from "react";
import { Flex } from "@appsmith/ads";
import { ToolCheckList } from "./ToolCheckList";
import { ToolHeader } from "./ToolHeader";
import type { Tool, ToolGroup as ToolGroupType } from "../types";
import { useBoolean } from "usehooks-ts";

interface ToolGroupProps {
  group: ToolGroupType;
  onSelectAll: (tools: Tool[], setSelectedTo: boolean) => void;
  onToolEdit: (tool: Tool, triggerSave?: boolean) => void;
  onToolSelect: (tool: Tool) => void;
}

export const ToolGroup = (props: ToolGroupProps) => {
  const { group, onSelectAll, onToolEdit, onToolSelect } = props;
  const { toggle: toggleExpanded, value: isExpanded } = useBoolean(false);

  return (
    <Flex
      border="1px solid var(--ads-v2-color-border)"
      borderRadius="var(--ads-v2-border-radius)"
      flexDirection="column"
      gap="spaces-2"
      key={group.id}
    >
      <ToolHeader
        icon={group.icon}
        isCollapsed={!isExpanded}
        name={group.name}
        onClick={toggleExpanded}
        selectedCount={group.tools.filter((tool) => tool.isSelected).length}
      />
      {isExpanded && (
        <ToolCheckList
          icon={group.icon}
          onSelectAll={onSelectAll}
          onToolEdit={onToolEdit}
          onToolSelect={onToolSelect}
          tools={group.tools}
        />
      )}
    </Flex>
  );
};
